import { CoreModule } from '@abp/ng.core';
import { ThemeSharedModule } from '@abp/ng.theme.shared';
import { NgModule } from '@angular/core';
import { NgbCollapseModule, NgbDatepickerModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxValidateCoreModule } from '@ngx-validate/core';
import { CommercialUiModule } from '@volo/abp.commercial.ng.ui';
import { PageModule } from '@abp/ng.components/page';
import { AssetModelComponent } from './components/asset-model.component';
import { AssetModelRoutingModule } from './asset-model-routing.module';

@NgModule({
  declarations: [AssetModelComponent],
  imports: [
    AssetModelRoutingModule,
    CoreModule,
    ThemeSharedModule,
    CommercialUiModule,
    NgxValidateCoreModule,
    NgbCollapseModule,
    NgbDatepickerModule,
    NgbDropdownModule,
    PageModule
  ],
})
export class AssetModelModule {}

export function loadAssetModelModuleAsChild() {
  return Promise.resolve(AssetModelModule);
}
